import fetcher from 'api/fetcher';
import { MagritteNotificationName } from 'utils/constants/notification';

import { fetchRemainingAiImageGenerations } from 'components/common/BannerImg/AiImageGenerationModal/fetchRemainingAiImageGenerations';

import { setGenerationQueueId } from 'store/models/aiImageGeneration';
import { addMagritteNotification } from 'store/models/notification';
import { AppThunkAction } from 'store/utils';

export const cancelAiImageGeneration = (aiImageQueueId: number): AppThunkAction<void> => {
    return (dispatch) => {
        void fetcher
            .put(`/api/v1/images/ai/${aiImageQueueId}/cancel`)
            .then(() => {
                dispatch(setGenerationQueueId(null));
            })
            .then(() => {
                void dispatch(fetchRemainingAiImageGenerations());
            })
            .catch(() => {
                dispatch(addMagritteNotification(MagritteNotificationName.AiImageGenerationSomethingWentWrong));
            });
    };
};
